import {Chip, Navbar, NavbarBrand, NavbarContent, NavbarItem} from "@heroui/react";
import {RSKLogo} from "../components/NavBar";
import {CgDarkMode} from "react-icons/cg";
import React, {useCallback, useMemo, useState} from "react";
import {AgGridReact} from "@ag-grid-community/react";
import axios from "axios";
import {reorderColumns} from "../utils/aggrid";
import {LegacyOptionsToolPanel} from "../components";


const LegacyPublic = ({ darkMode }) => {
    // Row Data: The data to be displayed.
    const [rowData, setRowData] = useState();

    // Column Definitions: Defines the columns to be displayed.
    const [colDefs, setColDefs] = useState([]);

    const [gridApi, setGridApi] = useState(null);

    const defaultColDef = useMemo(() => {
        return {
            filter: 'agTextColumnFilter',
            floatingFilter: true,
        };
    }, []);
    const rowSelection = useMemo(() => {
        return {
            mode: "singleRow",
            checkboxes: false,
            enableClickSelection: true,
        };
    }, []);

    const getRowId = useCallback((params) => String(params.data.s_id), []); //ajustar al id

    const editableColumns = [
    ];

    const getMoneySymbolByColumn = (columnName) => {
        let symbol;
        switch(columnName){
            case 's_monto_reclamado':
            case 's_monto_pagado':
            case 's_monto_recuperado_responsable_final':
                symbol = '$';
                break;

            case 'mr_reclamo_euros':
            case 'mr_recuperado_euros':
                symbol = '€';
                break;

            default:
                symbol = '';
                break;
        }
        return symbol
    }

    const setColumTypeFromMariaDBTableDefinition = (column) => {
        // Procesar el headerName
        const headerName = column.Field.includes('_')
            ? column.Field.split('_') // Divide por '_'
                .slice(1) // Toma todo después del primer '_'
                .map((word, index) =>
                    index === 0
                        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Primera palabra capitalizada
                        : word.toLowerCase() // Siguientes palabras en lowercase
                )
                .join(' ') // Une sin separadores
            : column.Field;

        let colData = {
            //columnGroupShow: 'open',
            headerName: headerName
        };
        switch(column.Type){
            case "date":
                colData =
                    {
                        ...colData,
                        field: column.Field, cellEditor: 'agDateCellEditor',
                        filter: 'agDateColumnFilter',
                        valueGetter: (params) => {
                            //Convertir a fecha de JS
                            return params.data && params.data[column.Field] ? new Date(params.data[column.Field]) : null;
                        },
                        valueFormatter: (params) => {
                            // Formatea la fecha para mostrarla como texto en la celda
                            return params.value ? params.value.toLocaleDateString() : '';
                        },
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                        enableRowGroup: true,
                        enablePivot: true,
                    };

                break;
            case "varchar(100)":
            case "varchar(256)":
            case "varchar(255)":
            case "text": //no character limit
                colData = {
                    ...colData,
                    field: column.Field, cellEditor: 'agLargeTextCellEditor', editable: editableColumns.includes(column.Field),
                    cellEditorPopup: true,
                    cellClassRules: {
                        'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                    },
                    enableRowGroup: true,
                    enablePivot: true,
                };

                break;
            case "smallint(5)": //numeric_precision: 16 (smallint = 16) / numeric_scale (normally numeric scale for smallint is 0)
            case "tinyint(1)": //numeric_precision: 32 (int32) / numeric_scale both integers (normally numeric scale for integer is 0)
                colData = {
                    ...colData,
                    field: column.Field,
                    cellEditor: 'agNumberCellEditor',
                    editable: editableColumns.includes(column.Field),
                    cellClassRules: {
                        'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                    },
                    enableValue: true,
                }

                break;
            default:
                colData = {
                    ...colData,
                    field: column.Field, editable: editableColumns.includes(column.Field),
                    cellClassRules: {
                        'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                    },
                };
                break;
        }

        return colData;
    }

    const onGridReady = useCallback(async (params) => {

        try {
            // Obtener definición de columnas
            const response = await axios.get('https://quickview.rskgroupco.com/app/legacy/describe', {
                headers: {
                    'Content-Type': 'application/json'
                },
                timeout: 10000 // 10s timeout
            });
            const columnDefinitions = response.data;

            const colDefs = columnDefinitions.map(setColumTypeFromMariaDBTableDefinition);

            const priorityColumns = ["s_rsk", "s_container_a"];
            const reorderedColDefs = reorderColumns(colDefs, priorityColumns)

            setColDefs(reorderedColDefs);
            // Obtener datos filtrados
            const responseData = await axios.get('https://quickview.rskgroupco.com/app/legacy/listar', {
                headers: {
                    'Content-Type': 'application/json'
                },
                timeout: 10000 // 10s timeout
            });
            const rowData = responseData.data;
            setRowData(rowData);
        } catch (error) {
            console.error('Error al cargar los datos:', error);
        }

        setGridApi(params.api); //setear el gridapi para pasarlo al toolpanel

    }, []);

    const sideBar = useMemo(() => {
        return {
            toolPanels: [
                {
                    id: "columns",
                    labelDefault: "Columns",
                    labelKey: "columns",
                    iconKey: "columns",
                    toolPanel: "agColumnsToolPanel",
                },
                {
                    id: "filters",
                    labelDefault: "Filters",
                    labelKey: "filters",
                    iconKey: "filter",
                    toolPanel: "agFiltersToolPanel",
                },
                {
                    id: "options",
                    labelDefault: "Options Panel",
                    labelKey: "optionsPanel",
                    iconKey: "options-panel",
                    toolPanel: LegacyOptionsToolPanel,
                    toolPanelParams: {
                        title: (
                            <span style={{ fontWeight: "normal", color: "black", fontSize: 20}}>
                                Opciones
                            </span>
                        ),
                        toolPanelParams: { gridApi },
                    },
                },
            ],
            defaultToolPanel: "options",
        };
    }, [gridApi]);

    return (
        <>
            <Navbar>
                <NavbarBrand>
                    <h1 style={{ fontFamily: "'Lato', sans-serif", fontSize: '2rem', fontWeight: '700', letterSpacing: '1px' }}>
                        Sistema Legado
                    </h1>
                </NavbarBrand>

                {/*<NavbarContent className="hidden sm:flex gap-4" justify="center">*/}
                {/*        <NavbarItem key="1">*/}
                {/*            <Chip>RSK Files</Chip>*/}
                {/*        </NavbarItem>*/}
                {/*</NavbarContent>*/}

                <NavbarContent justify="end">
                    <NavbarItem>
                    <span style={{ cursor: 'pointer' }} aria-label="Toggle Dark Mode">
                        <CgDarkMode size={20} />
                    </span>
                    </NavbarItem>
                </NavbarContent>
            </Navbar>

            <div
                className={`${darkMode ? "ag-theme-balham-dark" : "ag-theme-balham"} h-[calc(100vh-64px)] w-full`}
            >
                <AgGridReact
                    rowData={rowData}
                    columnDefs={colDefs}
                    defaultColDef={defaultColDef}
                    rowSelection={rowSelection}
                    getRowId={getRowId}
                    sideBar={sideBar}
                    onGridReady={onGridReady}
                />
            </div>
        </>
    )
}

export default LegacyPublic;